<template>
  <client-only>
    <div id="social-box">
      <ShareNetwork
        network="facebook"
        :url="url"
        :title="'title'"
        :description="description"
        :quote="quote"
        hashtags="דרושים,פורטל דרושים,דרושים IL"
      >
        <i class="icon-facebook2 pointer" />
      </ShareNetwork>
      <ShareNetwork
        network="email"
        :url="url"
        :title="title"
        :description="description"
        :quote="quote"
        hashtags="דרושים,פורטל דרושים,דרושים IL"
      >
        <i class="icon-mail4 pointer" />
      </ShareNetwork>
      <ShareNetwork
        network="whatsapp"
        :url="url"
        :title="title"
        :description="description"
        :quote="quote"
        hashtags="דרושים,פורטל דרושים,דרושים IL"
      >
        <i class="icon-whatsapp pointer" />
      </ShareNetwork>
      <ShareNetwork
        network="linkedin"
        :url="url"
        :title="title"
        :description="description"
        :quote="quote"
        hashtags="דרושים,פורטל דרושים,דרושים IL"
      >
        <i class="icon-linkedin pointer" />
      </ShareNetwork>
    </div>
  </client-only>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    quote: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
}
</script>


<style lang="css" scoped>
#social-box {
  background: #fff;
}
#social-box a i {
  font-size: 20px;
  margin: 0 4px;
}

#social-box i {
  font-size: 20px;
  margin: 0 4px;
}
</style>
